import React from 'react';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { FormState } from './types';
import { classNames } from 'primereact/utils';

interface DialogHeaderProps {
  formData: Partial<FormState>;
  onUpdateFormData: (data: Partial<FormState>) => void;
  errors?: {
    poNumber?: string;
    notes?: string;
  };
}

const DialogHeader: React.FC<DialogHeaderProps> = ({
  formData,
  onUpdateFormData,
  errors
}) => {
  return (
    <div className="p-fluid">
      <div className="field">
        <label htmlFor="poNumber" className={classNames({ 'p-error': errors?.poNumber })}>
          PO Number *
        </label>
        <InputText
          id="poNumber"
          value={formData.poNumber || ''}
          onChange={(e) => onUpdateFormData({ ...formData, poNumber: e.target.value })}
          className={classNames({ 'p-invalid': errors?.poNumber })}
          placeholder="Enter Purchase Order Number"
        />
        {errors?.poNumber && (
          <small className="p-error">{errors.poNumber}</small>
        )}
      </div>

      <div className="field">
        <label htmlFor="notes" className={classNames({ 'p-error': errors?.notes })}>
          Notes
        </label>
        <InputTextarea
          id="notes"
          value={formData.notes || ''}
          onChange={(e) => onUpdateFormData({ ...formData, notes: e.target.value })}
          className={classNames({ 'p-invalid': errors?.notes })}
          placeholder="Enter Notes"
          rows={3}
          autoResize
        />
        {errors?.notes && (
          <small className="p-error">{errors.notes}</small>
        )}
      </div>
    </div>
  );
};

export default DialogHeader;
